import sbjs from 'sourcebuster'
import {setCookie, getCookie, detectDevice, getDPI, getScreenSize, getFingerprint, pushFBEvent, GetURLParameter, addPhoneMask, setDefaultValues, newAmountControllers, cookieBar, addSumMask, crezuEvent, generateUUIDv4} from './helpers'

import $ from 'jquery'
import {simpleProcessInit} from './simpleProcess'

window.$ = $;
window.getCookie = getCookie
window.setCookie = setCookie

// FB event when index page is loaded
if (window.location.pathname === '/' || window.location.pathname === '/index' || window.is_main_page) {
  pushFBEvent('track', 'ViewContent', {content_name: 'Homepage'})
  sbjs.init({
    lifetime: 3
  });

  $.ajax({
    url: '/index.json',
    type: 'get',
    dataType: 'json',
    complete: function (data) {
      if (!window.simpleProcessEnabled) {
        $('#loader').fadeOut()
      } else {
        setTimeout(function () {
          console.log('reserve loader hider')
          $('#loader').fadeOut()
        }, 5000)
      }
      const config = JSON.parse(data.responseText)
      if (config.global.show_cookie_bar && +config.global.countryId !== 8) cookieBar(config)
      const sumSeparator = config.info.sumSeparator || ' '
      addPhoneMask(config.info.phone_mask)
      addSumMask(sumSeparator)

      window.gclid = GetURLParameter('gclid') ? GetURLParameter('gclid') : '';
      if (window.gclid) setCookie('gclid', window.gclid, 1 / 48) // set gclid to cookie for 30 min

      if (GetURLParameter('fbclid') && !getCookie('_fbc')) {
        setCookie('_fbc', `fb.1.${Date.now()}.${GetURLParameter('fbclid')}`, 1 / 48)
        console.warn('_fbc setted manually')
      }

      window.user_fingerprint = 'default'
      getFingerprint()
      window.ga_client_id = '';
      window.globalConfig = window.globalConfig || {}
      window.globalConfig.min_loan_amount = config.info.min_loan_amount
      window.globalConfig.max_loan_amount = config.info.max_loan_amount
      window.globalConfig.step_loan_amount = config.info.step_loan_amount
      newAmountControllers(sumSeparator)

      // firebase register token
      window.back_fcm = 'https://crezu.net:8002'
      window.globalConfig.country = config.global.countryId
      window.globalConfig.provider = config.global.providerId
      const fcm = document.createElement('script')
      fcm.setAttribute('src', `https://cdn.crezu.net/landings/js/get_token_with_custom_prompt.js?rand=${+new Date()}`)
      document.head.appendChild(fcm)

      let isAR = config.global.country === 'AR'
      let phoneMask
      try {
        phoneMask = config.info.defPhone + config.info.phone_mask.slice(config.info.defPhone.length).replace(/9/g, '_')
      } catch (e) {
        phoneMask = 'no phone mask'
      }
      console.log('phone mask is:', phoneMask)

      setDefaultValues(config.info.defAmount, config.info.defPhone)

      setTimeout(function() {
        // GA4
        const gaCookie = getCookie('_ga');
        if (gaCookie) ga_client_id = gaCookie.split('.').slice(2).join('.')
        //GA UA
        if (typeof(ga) != 'undefined')
          ga(function() {
            var trackers = ga.getAll();
            if (trackers) {
              ga_client_id = trackers[0].get('clientId')
            }
          });
      }, 1000);

      function getPhone () {
        let phone = $('[name=phone]').val().split(' ').join('')
        let ar_phone_code, ar_phone = ''
        if (config.global.country === 'VN') phone = '+84' + phone
        if (isAR) {
          ar_phone_code = $('[name=ar-phone-code]').val()
          ar_phone = $('[name=ar-phone]').val()
          phone = '+54' + ar_phone_code + ar_phone
        }
        if (window.location.hostname === 'creditotierra.com') phone = '+52' + phone
        return {
          phone: phone,
          'ar-phone-code': ar_phone_code,
          'ar-phone': ar_phone
        }
      }

      function auth() {
        $('.preloader-landing').removeClass('hidden')
        console.log("call auth")
        localStorage.removeItem('authAutocomplete')
        localStorage.setItem('amount', $('[name=loan_sum]').val().split(sumSeparator).join(''))
        let postData = $('.form_index').serializeArray()
        let additionalData = {
          loan_period: 30,
          loan_sum: $('[name=loan_sum]').val().split(sumSeparator).join(''),
          phone: getPhone().phone,
          utm_source: GetURLParameter('utm_source') || sbjs.get.current.src,
          utm_medium: GetURLParameter('utm_medium') || sbjs.get.current.mdm,
          utm_campaign: GetURLParameter('utm_campaign') || sbjs.get.current.cmp,
          utm_content: GetURLParameter('utm_content') || sbjs.get.current.cnt,
          utm_term: GetURLParameter('utm_term') || sbjs.get.current.trm,
          country: config.global.countryId,
          provider: config.global.providerId,
          ga_client_id: ga_client_id || GetURLParameter('ga_client_id'),
          gclid: gclid,
          domain: window.location.hostname,
          fingerprint: window.user_fingerprint,
          appsflyer_id: GetURLParameter('appsflyer_id') || 'none',
          advertising_id: GetURLParameter('advertising_id') || 'none',
        }

        if (additionalData.domain === 'pera-ph.com') additionalData.fullURL = window.location.href

        // new Android detector
        additionalData.device = detectDevice()

        // facebook ids
        additionalData.fb_fpc = getCookie('_fbc')
        additionalData.fb_fbp = getCookie('_fbp')

        // screen info for antifrod
        additionalData.screen_size = getScreenSize()
        additionalData.dpi = getDPI()

        for (var key in additionalData) {
          postData.push({
            name: key,
            value: additionalData[key]
          })
        }
        $.ajax({
          url: `${config.global.backendurl}/simple-auth`,
          type: 'post',
          dataType: 'json',
          data: postData,
          success: function (data) {
            data.data.customer['loan_sum'] = $('[name=loan_sum]').val().split(sumSeparator).join('')
            data.data.customer['timestamp'] = Date.now() / 1000 | 0
            localStorage.setItem('authAutocomplete', JSON.stringify(data.data.customer))
            localStorage.setItem('leadId', data.data.lead_id)
            localStorage.setItem('lead_status', data.data.lead_status)
            console.log(data)
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'simpleAuth'
            })
            goToRegForm()
          },
          error: function (e) {
            goToRegForm()
            if (e.responseText.indexOf('Duplicate customer') > -1) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'duplicateCustomer'
              })
            }
          }
        })
      }

      let reg, flag
      if (!isAR) {
        reg = {
          phone: config.info.phone_regex
        }
        flag = {
          phone: ($('[name=phone]').val()).length > 0
        }
      } else {
        reg = {
          "ar-phone-code": config.info.phone_regex[0],
          "ar-phone": config.info.phone_regex[1],
        }
        flag = {
          "ar-phone-code": ($('[name=ar-phone-code]').val()).length > 0,
          "ar-phone": ($('[name=ar-phone]').val()).length > 0
        }
      }

      function validate(name, value) {
        let regPattern = new RegExp(reg[name])
        return regPattern.test(value)
      }

      let inputsSelector
      if (!isAR) {
        inputsSelector = $('[name=phone]')
      } else {
        inputsSelector = $('[name=ar-phone-code], [name=ar-phone]')
      }

      inputsSelector.on('blur', function () {
        let selector = $(this)
        let name = selector.attr('name')
        let value = selector.val()
        if (!validate(name, value) && value !== '') {
          selector.addClass("error")
          flag[name] = false
        } else if (value === '') {
          selector.removeClass("error")
          flag[name] = true
        }
      })

      inputsSelector.on('keyup', function () {
        let selector = $(this)
        let name = selector.attr('name')
        let value = selector.val()
        if (validate(name, value)) {
          selector.removeClass("error")
          flag[name] = true
        }
      })

      $('.to_reg').on('click', function (e) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'clickCTA'
        })
        console.log("click main form", flag)
        let phoneDict = getPhone()
        let dataFromFirstStep = {
          amount: $('[name=loan_sum]').val().split(sumSeparator).join('')
        }
        if (phoneDict.phone !== phoneMask.split(' ').join('')) dataFromFirstStep.phone = phoneDict.phone
        if (isAR) {
          dataFromFirstStep = {
            ...dataFromFirstStep,
            ...phoneDict
          }
          delete dataFromFirstStep.phone
        }
        localStorage.setItem('dataFromFirstStep', JSON.stringify(dataFromFirstStep))
        e.preventDefault()
        $('.to_reg').prop('disabled', true)
        $('#loader').fadeIn()
        if (Object.keys(flag).map(k => !!flag[k] && ($(`[name=${k}]`).val()).length > 0 && $(`[name=${k}]`).val() !== phoneMask).every(v => !!v)) {
          console.log('ALL VALID')
          auth()
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'clickCTAFilled'
          })
        } else if (Object.keys(flag).map(k => $(`[name=${k}]`).val() === '').every(v => !!v)) {
          console.log('ALL EMPTY')
          goToRegForm()
        } else if (Object.keys(flag).map(k => $(`[name=${k}]`).val() === phoneMask).every(v => !!v)) {
          console.log('DEF PHONE WITH MASK')
          goToRegForm()
        } else {
          console.log('PHONE INVALID')
          $('.to_reg').prop('disabled', false)
          $('#loader').fadeOut()
          $('[name=phone]').addClass("error").keyup()
          $('[name=ar-phone-code]').addClass("error").keyup()
          $('[name=ar-phone]').addClass("error").keyup()
        }
      })

      simpleProcessInit()

      if (!getCookie('uuidv4')) crezuEvent({
        event_id: 1,
        provider_id: config.global.providerId,
        domain: window.location.hostname,
        session_id: generateUUIDv4(),
        referer: document.referrer,
        utm_source: GetURLParameter('utm_source') || sbjs.get.current.src,
        utm_medium: GetURLParameter('utm_medium') || sbjs.get.current.mdm,
        utm_campaign: GetURLParameter('utm_campaign') || sbjs.get.current.cmp,
        utm_content: GetURLParameter('utm_content') || sbjs.get.current.cnt,
        utm_term: GetURLParameter('utm_term') || sbjs.get.current.trm,
      })
    }
  })

  function goToRegForm () {
    let regURL = '/reg'
    if (['namo.com.ua', 'helptowallet.com', 'afinero.net', 'creditotierra.com', 'instamonie.com', 'myhryvnia.com', 'tengerad.com'].indexOf(window.location.hostname) > -1) {
      let branch = 1
      if (window.location.pathname === '/index2') branch = 2
      regURL += '?flowbranch=' + branch
    }
    window.location.href = regURL
  }
}
